import {
  emptyString,
  globalConstants,
  userPermissionsConstants,
} from "../../constants";

//Destructuring global constants
const { SUCCESS, FAILURE } = globalConstants;

//Destructuring user permission constants
const {
  USER,
  USER_PERMISSION_DATA,
  PERMISSION_DATA,
  UPDATE_USER_PERMISSION,
  USER_PERMISSION_DELETED,
  USER_DATA,
  RESET_PASSWORD_USER_PERMISSION,
  VERIFY_PASSWORD,
  GET_USER_PERMISSION_EMAILS,
} = userPermissionsConstants;

//Default state of account reducer
const initialState = {
  userPermissionData: [],
  permissionData: [],
  permissionDataPagination: {
    size: 10,
    totalElements: 0,
    number: 0,
  },
  userData: [],
  user: null,
  userDeleted: emptyString,
  resetPasswordResponse: emptyString,
  verifyPasswordResponse: emptyString,
};

//Manipulating the state of account based on actions and returning the state
export const userPermissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_PERMISSION_DATA + SUCCESS:
      return { ...state, userPermissionData: action.data };
    case PERMISSION_DATA + SUCCESS:
      return {
        ...state,
        permissionData: action.data.data,
        permissionDataPagination: action.data.page,
      };
    case UPDATE_USER_PERMISSION + SUCCESS:
      return { ...state, userPermissionData: action.data };
    case USER_PERMISSION_DELETED + SUCCESS:
      return { ...state, userDeleted: action.data };
    case USER_DATA + SUCCESS:
      return { ...state, userData: action.data };
    case USER + SUCCESS:
      return { ...state, user: action.data };
    case RESET_PASSWORD_USER_PERMISSION + SUCCESS:
      return { ...state, resetPasswordResponse: action.data };
    case RESET_PASSWORD_USER_PERMISSION + FAILURE:
      return { ...state, resetPasswordResponse: emptyString };
    case VERIFY_PASSWORD + SUCCESS:
      return { ...state, verifyPasswordResponse: action.data };
    case VERIFY_PASSWORD + FAILURE:
      return { ...state, verifyPasswordResponse: emptyString };
    case GET_USER_PERMISSION_EMAILS + SUCCESS:
      return {
        ...state,
        userPermissionEmails: action.data.data,
      };
    case GET_USER_PERMISSION_EMAILS + FAILURE:
      return {
        ...state,
        userPermissionEmails: [],
      };
    default:
      return state;
  }
};
